import React from 'react';

const About = () => {
  return (
    <div className="page">
      <div className="container">
        <h1>About Savory Haven</h1>
        <p>We are a full-service restaurant marketing agency dedicated to helping restaurants thrive in the digital age.</p>
      </div>
    </div>
  );
};

export default About;
